import { render, staticRenderFns } from "./borclulistesi.vue?vue&type=template&id=0b4d1de4&scoped=true"
import script from "./borclulistesi.vue?vue&type=script&lang=js"
export * from "./borclulistesi.vue?vue&type=script&lang=js"
import style0 from "./borclulistesi.vue?vue&type=style&index=0&id=0b4d1de4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d1de4",
  null
  
)

export default component.exports